
import {define} from "observable:runtime";
import asset1 from "./style.css?url";
import asset2 from "./favicon.svg?url";

const assets = new Map([
  ["./style.css", asset1],
  ["./favicon.svg", asset2]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const {installThemeToggle, installHashImportBanner} = await import("./lib/helpers.js").then((module) => {
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  return module;
});
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
return {installThemeToggle,installHashImportBanner};
},
    inputs: ["html","display"],
    outputs: ["installThemeToggle","installHashImportBanner"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
